export const makePersistId = appId => `migration-completed-banner-${appId}`;
